import { render, staticRenderFns } from "./NextToOrder.vue?vue&type=template&id=7001cbab&scoped=true"
import script from "./NextToOrder.vue?vue&type=script&lang=js"
export * from "./NextToOrder.vue?vue&type=script&lang=js"
import style0 from "./NextToOrder.vue?vue&type=style&index=0&id=7001cbab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7001cbab",
  null
  
)

export default component.exports